<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout row justify-center>
        <v-dialog v-model="dialog" max-width="1000">
                    <v-card>
                        <v-card-title>
                            {{ formTitle }}
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-form ref="form"  :lazy-validation="lazy" enctype="multipart/form-data">
                            <v-stepper v-model="e1">
                                <v-stepper-header>
                                    <v-stepper-step
                                            :complete="e1 > 1"
                                            step="1">
                                        {{$t('marchand.infos')}}
                                    </v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step
                                            :complete="e1 > 2"
                                            step="2">
                                        {{$t('marchand.info')}}
                                    </v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step
                                            :complete="e1 > 3"
                                            step="3">
                                       {{$t('marchand.finaliser')}}
                                    </v-stepper-step>

                                </v-stepper-header>
                                <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>

                                <v-alert v-if="errors.operation" dense outlined type="error">
                                    {{errors.operation}}
                                </v-alert>
                                <v-stepper-items>
                                    <v-stepper-content step="1">
                                        <v-container >
                                            <v-row >
                                               <h4>À SAVOIR</h4>
                                               <p>
                                                   En qualité de marchand, vous devez créer un compte business pour profiter des différents services paiements
                                                    que nous vous proposons.
                                               </p>
                                               <p>
                                                   Toutes les transactions serons liées à votre compte business, vous pouvez créer autant de compte business que vous le désirez.</p>
                                               <p>
                                                   Notez que vous devez fournir des informations et différents documents sur votre entreprises pour valider votre compte business et utiliser le mode 'Live' qui vous permet de recevoir de l'argent réel.
                                               </p>
                                            </v-row>
                                        </v-container>
                                            <v-btn color="secondary" class="mr-2"  small @click="logoutUser()">{{$t('leave')}}</v-btn>
                                                           <v-btn color="primary"  @click="e1 = 2" small>  {{$t('marchand.continue')}}
                                        </v-btn>
                                    </v-stepper-content>
                                    <v-stepper-content step="2">
                                        <v-container >
                                            <v-row>
                                                <h6 class="col-12">
                                                    Remplissez les informations demandées pour créer votre compte business maintenant.
                                                </h6>
                                               
                                                <v-col cols="12" sm="6">
                                                    <v-select :rules="countryRules" @change="countryChanged"   v-model="editedItem.country" item-text="_name" item-value="_id" :items="countries" :label="$t('marchand.pays')" single-line solo  ></v-select>
                                                </v-col>
                                                <v-col cols="12" sm="6" >
                                                    <v-select :rules="CategorieRules" @change="categorieChanged"   v-model="editedItem._categorie_id" item-text="_name" item-value="_id" :items="category_marchands" :label="$t('marchand.categorie')" single-line solo  required></v-select>
                                                </v-col>
                                                <v-col cols="12" sm="6" >
                                                    <v-text-field  :rules="CompanyRules"  v-model="editedItem._company" :label="$t('marchand.company') "  single-line solo ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" >
                                                    <v-text-field :rules="[rules.required,rules.email]"  v-model="editedItem._email" :label="$t('marchand.email')"  single-line solo ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12">
                                                    <v-text-field  v-model="editedItem._web_site" :label="$t('marchand.site_web')"  single-line solo ></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="12">
                                                <v-btn color="secondary" class="mr-2"  small @click="logoutUser()">{{$t('leave')}}</v-btn>

                                              <v-btn :disabled="!editedItem._company ||  !editedItem._email || !editedItem._categorie_id || !editedItem.country"
                                               color="primary"  small   @click="e1 = 3">  {{$t('marchand.continue')}}
                                        </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-stepper-content>
                                    <v-stepper-content step="3">
                                         <v-col cols="12">
                                             <div class="mb-3">
                                                 Veuillez lire et accepter les conditions d'utilisation ci-dessous.
                                             </div>
                                        <div style="height:200px;overflow-y:auto;border:1px solid #efefef;padding:20px">
                                           
                                       <h5>  Conditions d’utilisation d’INTRAM </h5>
<p>
      Les présentes conditions d'utilisation traduisent le fonctionnement de INTRAM, les lois qui s'appliquent à notre entreprise et certains principes que nous avons toujours tenus pour vrais. Par conséquent, ces conditions d'utilisation contribuent à définir votre relation avec INTRAM lorsque vous interagissez avec nos produits et services. Elles couvrent entre autres les thèmes suivants :
</p>
<div>
    <ul>
        <li>
Ce que vous pouvez attendre de notre part
</li><li>
Ce que nous attendons de votre part
</li><li>
Les droits de propriété intellectuelle associés aux contenus
</li><li>
Les droits dont vous jouissez et les conséquences d'une violation des présentes conditions d'utilisation
</li>
    </ul>
</div>
<p>
Il est essentiel de bien comprendre ces conditions, car vous les acceptez en utilisant nos services. Outre les présentes conditions, nous avons également publié des Conditions générales d’utilisations. Même si ces règles ne font pas partie de ces conditions, nous vous invitons à les lire attentivement afin de mieux comprendre comment modifier, gérer, exporter et supprimer vos données.
</p>


    <h5> Droits de propriété intellectuelle </h5>


<p> INTRAM, qui représente INTRAM ainsi que tous ces partenaires techniques, possède tous les droits de propriété intellectuelle sur ses plateformes et le contenu multimédia qui s’y trouve. Aucun de nos droits de propriété ne peut être concédé sous quelque forme que ce soit à une personne ayant accès à nos produits et services. Vous acceptez vous conformer à cet état de chose, et ne pourrez en aucun cas chercher à vous approprier ces droits de propriété.
</p>

<h5> Licence d'utilisation de nos plateformes </h5>

<p> Une licence non cessible, révocable par INTRAM et non exclusive, vous est accordée selon les conditions d’accès auxquelles vous acceptez de soumettre, durant toute la période pour laquelle INTRAM vous y autorise, dans le cadre de l’utilisation de nos produits et services. Sont inclus dans cette licence, toutes les actions de mise à jour nécessaire pour le bon fonctionnement des plateformes. Les services sont protégés par les lois sur le droit d'auteur, les marques de commerce et autres lois du Bénin et de pays étrangers. Rien dans cette clause ne vous donne le droit d'utiliser le nom INTRAM, PAYCFA ou l'une des marques commerciales, logos, noms de domaine, sous domaines, et autres caractéristiques distinctives de la marque INTRAM. Tous les droits, titres et intérêts relatifs aux services sont et resteront la propriété exclusive de INTRAM et de ses concédants de licence.
</p>
<p>
Néanmoins, vous conservez vos droits sur tout Contenu que vous soumettez, publiez ou affichez sur ou via les Services. Ce qui est à vous vous appartient. Vous êtes le propriétaire de votre Contenu (ce qui inclut vos sons, photos et vidéos intégrés).
</p>

<h5> Nos conditions : qui peut utiliser les services de INTRAM ? </h5>

<p> Le partenariat entre INTRAM et utilisateur tierce est encadré par un contrat. Vous ne pourrez utiliser nos services que si vous acceptez de le signer. Il faudra être certain de ne pas être interdit d’utiliser ce type de services et d’être poursuivi par une institution juridique. Il faudra prouver que vous êtes bien le représentant habilité et autorisé de la structure pour laquelle vous ouvrez un compte chez INTRAM.
</p>

<h5> Clause liée à la restriction d'âge </h5>

<p> Afin de nous adresser à des interlocuteurs avertis, nos différentes plateformes ainsi que les services que nous proposons aux personnes morales s'adressent aux adultes, et donc des personnes âgées d’au moins 18 ans. Nous faisons au mieux pour dissuader les personnes n’ayant pas au moins 18 ans d’âge.
</p>

<h5> Notre déclaration de garantie </h5>

<p> INTRAM vous rassure d’une haute disponibilité de ses plateformes, et la résolution dans les meilleures délais des problèmes qui pourraient survenir. Nous nous assurons de la sécurisation de nos plateformes, et mettons tout en œuvre pour ne pas mettre votre système d’information en danger. Néanmoins, en tant que fédérateur de plusieurs technologies, nous fournissons «tels quels» tout matériel sans aucune garantie, expresse ou tacite, de quelque nature que ce soit. Nous déclinons expressément toutes garanties et conditions, y compris toute garantie implicite ou condition de valeur marchande, d'aptitude à un besoin particulier, de disponibilité, de sécurité, de titre et de non-violation des droits de propriété intellectuelle. Dans le cadre de la tenue aucune garantie que notre site web et ses services répondra à vos besoins, ni que notre site web restera exempt de toute interruption, bogues, inaccuracies et exempt d'erreur. Vous utilisez nos services à vos propres risques et vous êtes les seuls responsables de tout dommage résultant d'une perte de données ou d'un dommage à votre système informatique.
</p>

<h5> Amélioration et performance</h5>
<p>
Nous développons en permanence de nouvelles technologies et fonctionnalités en vue d'améliorer nos services. Par exemple, nous investissons dans l'intelligence artificielle, qui s'appuie sur le machine learning (apprentissage automatique), pour détecter et bloquer le spam et les logiciels malveillants, et pour vous proposer des fonctionnalités innovantes telles que la traduction simultanée. Dans le cadre de ces améliorations continues, nous pouvons être amenés à ajouter ou supprimer des fonctionnalités, à modifier les limites de nos services, à proposer de nouveaux services et à en abandonner d'autres plus anciens.
</p>
<p>
En cas de modifications importantes ayant un impact négatif sur votre utilisation de nos services ou de suppression d'un service, nous vous adresserons un préavis dans un délai raisonnable qui vous laissera la possibilité d'exporter vos contenus, sauf dans des situations urgentes, telles que la prévention d'abus ou la réponse à des obligations légales, ou en cas d'impératifs liés à des questions de sécurité ou de fonctionnalité.
</p>

<h5> Clause de limitation de responsabilité </h5>

<p> Vous êtes responsable de l’utilisation que vous faites des Services et de tout Contenu que vous fournissez, y compris de la conformité aux lois, règles et réglementations en vigueur. Vous ne devez fournir un Contenu que dans la mesure où cela ne vous gêne pas de le partager avec d’autres.
</p>
<p>
Tout usage ou recours à un Contenu ou à des matériaux affichés par l’intermédiaire des Services, ou que vous obtenez par ce moyen, est réalisé à vos risques et périls. Nous n’approuvons, ne soutenons, ne déclarons et ne garantissons pas l’exhaustivité, la véracité, l’exactitude ou la fiabilité d’un quelconque Contenu ou d’une quelconque information publiée via les Services, ni ne cautionnons aucune des opinions exprimées par leur intermédiaire. Vous comprenez qu’en utilisant les Services, vous risquez d’être exposé(e) à un Contenu qui peut être offensant, malfaisant, inexact ou inapproprié, voire, dans certains cas, à des messages qui auraient été mal adressés ou qui s’avèreraient trompeurs. Tout Contenu relève de la seule responsabilité de la personne qui l’a créé. Nous ne surveillons et ne contrôlons pas nécessairement tous les Contenus publiés via les Services, et nous ne pouvons en assumer la responsabilité.
</p>
<p>
Nous nous réservons le droit de supprimer tout Contenu qui violerait l’Accord d’utilisation, parce qu’il constituerait – par exemple - une violation de droits d’auteur ou de marques de commerce ou tout autre détournement de la propriété intellectuelle, une appropriation illicite de droits de propriété intellectuelle, une usurpation d’identité, une conduite illicite ou un harcèlement. Notre Centre d’assistance fournit des informations sur les politiques spécifiques et la procédure destinée à signaler ou à contester lesdites violations.
</p>
<p>
Si vous estimez que votre Contenu a été copié d’une manière constituant une contrefaçon de droits d’auteur, veuillez le signaler au plus tôt.
</p>

<h5> Indemnité </h5>

<p>> Par les présentes, vous indemnisez INTRAM et vous vous engagez à le faire pour tous dommages, pertes, coûts, responsabilités et dépenses (y compris, sans limitation, des frais juridiques raisonnables) résultant d'une violation par vous de l'une des dispositions des présentes Conditions ou d'une réclamation.
</p>
<h5> Rupture de ces termes </h5>

<p> Sans préjudice des autres droits de INTRAM en vertu des présentes Conditions, si vous ne respectez pas ces Conditions, INTRAM pourra prendre les mesures qu'il jugera appropriées pour remédier à la violation, notamment en suspendant votre accès aux différentes plateformes, en vous interdisant l'accès au site Web, en bloquant les terminaux utilisant votre adresse IP pour accéder au site Web, en contactant votre fournisseur de services Internet pour lui demander de bloquer votre accès au site Web et / ou en entamant des poursuites judiciaires à votre encontre.
</p>

<h5> Cookies </h5>

<p> Comme de nombreux autres plateformes, nous utilisons des cookies pour vous identifier en tant qu'utilisateur et pour personnaliser et améliorer nos services. Un cookie est un petit fichier de données qui est transféré sur votre ordinateur ou votre appareil mobile. Cela nous permet de mémoriser les informations de connexion à votre compte, les adresses IP, le trafic Web, le nombre de visites, la date et l'heure des visites. Certains navigateurs peuvent accepter automatiquement les cookies, tandis que d'autres peuvent être modifiés pour les refuser ou vous avertir lorsqu'un site Web souhaite créer un cookie sur votre ordinateur. Si vous choisissez de désactiver les cookies, cela pourrait limiter votre capacité à utiliser notre site Web.
</p>
<h5> Loi applicable </h5>

<a href="https://apdp.bj/wp-content/uploads/2019/04/CODE-DU-NUMERIQUE-DU-BENIN_2018-version-APDP.pdf" _traget="blank">https://apdp.bj/wp-content/uploads/2019/04/CODE-DU-NUMERIQUE-DU-BENIN_2018-version-APDP.pdf</a>     

<h5> Général </h5>

<p> Nous pouvons réviser ces conditions de temps à autre. Les modifications ne seront pas rétroactives et la version la plus récente des Conditions régira nos relations avec vous. Nous essayerons également de vous informer de tout changement important qui pourrait être effectué, par courrier électronique associé à votre notification de compte ou de service. En continuant à utiliser nos services après l'entrée en vigueur des modifications, vous acceptez d'être lié par les Conditions révisées. Si l'une de ces conditions est jugée invalide ou inapplicable, cette disposition sera alors limitée ou supprimée dans la mesure nécessaire, et les dispositions restantes de ces conditions resteront pleinement en vigueur. Le défaut de INTRAM de faire respecter un droit ou une disposition de ces Conditions ne sera pas considéré comme une renonciation à ce droit ou à cette disposition.
</p>

<h6> TYPES DE SOUS-COMMERCANTS INTERDITS ET NÉCESSITANT PRÉ-APPROBATION </h6>

<h6> SOUS-COMMERÇANTS NÉCESSITANT UNE PRÉAPPROBATION </h6>
  
<p> INTRAM ne sollicitera ni ne signera d’entente avec des marchands ou sous-marchands (i) appartenant à l’une des catégories / activités suivantes, ou (ii) menant l’une des activités suivantes à moins que INTRAM ne se lance dans un vaste programme avec un partenaire de référence, de technologie ou de marché spécialisé dans ces types d’activités ou d’entreprises, ce programme étant préalablement approuvé par INTRAM à sa seule discrétion:
</p>
<div>
    <ul>
        <li>
            
Produits ou services restreints à l'âge.
</li> <li>
Services de caution ou de faillite.
</li> <li>
Collecte de fonds participative telle que définie par INTRAM. Elle est toutefois interdite en ce qui concerne l'achat d'actions. La promesse faite étant de fournir un bien ou un service à l'avenir.
</li> <li>
Services de rencontres.
</li> <li>
ONG / organismes de bienfaisance.
</li> <li>
Virements de fonds, virements télégraphiques, mandats, émetteurs et encaissement de chèques, y compris les marchands, sauf s’ils sont enregistrés et titulaires d’une licence en tant qu’entreprise de services monétaires ou d’opérateurs de transferts monétaires.
</li> <li>
Facilitateurs de paiement (sauf s'ils sont enregistrés et autorisés)
</li> <li>
Produits d'amélioration personnelle et / ou nutraceutiques.
        </li>
    </ul>
</div>
<p> Des informations personnelles supplémentaires peuvent être obtenues à partir d'applications tierces et d'autres services d'identification / vérification, par exemple, de votre institution financière. Une fois que vous commencez à utiliser nos services, nous conservons tous les enregistrements de vos transactions et nous ne partagerons ni ne divulguerons vos informations personnelles avec des tiers sans votre consentement.
</p>

<h6> SOUS-COMMERCANTS INTERDITS </h6>

<p> INTRAM ne sollicitera ni ne signera d’ententes avec des marchands ou sous-marchands (i) appartenant à l’une des catégories / activités suivantes, ou (ii) exerçant l’une des activités suivantes, cette liste pouvant être mise à jour de temps à autre par INTRAM à sa seule discrétion. Sont interdits par INTRAM et / ou les règles de la marque de carte bancaire:
</p>
<div>
    <ul>
        <li>
            
Tout produit, service ou activité trompeur, injuste, prédateur ou interdit par une ou plusieurs marques de cartes bancaires.
</li> <li>
Tout marchand vendant des biens ou des services qui constituent une violation de toute loi, statut ou réglementation.
</li> <li>
Tout marchand vendant des produits qui enfreignent les droits de propriété intellectuelle d'autrui, y compris des produits contrefaits ou tout produit ou service qui enfreint le droit d'auteur, la marque ou les secrets commerciaux de tiers, tels que de nombreux Cyberlockers.
</li> <li>
Tout commerçant acceptant une carte comme moyen de paiement pour un chèque impayé ou pour un article jugé irrécouvrable par un autre commerçant.
</li> <li>
Tout commerçant qui accepte une carte à un terminal de distribution de certificats.
</li> <li>
Sites Web de divertissement pour adultes et / ou de contenu pour adultes, y compris les marchands de contenu pour adultes (vidéo-texte) de commerce électronique, tels que les 5967, 7273 et 7841 de MCC.
</li> <li>
Bestialité
</li> <li>
Activités préjudiciables, potentielles ou non, liées à la marque ou à la réputation, y compris la pornographie mettant en scène des enfants, les services d’escorte, les promises par correspondance, les occultes.
</li> <li>
Portefeuille numérique, sociétés cryptographiques ou prépayées.
</li> <li>
Attirail de drogue.
</li> <li>
E-cigarettes.
</li> <li>
Armes à feu et armes, y compris munitions.
</li> <li>
Pharmacies Internet / vente par correspondance.
</li> <li>
Investir ou «devenir riche rapidement», marchands, entreprises ou programmes.
</li> <li>
Dispensaires de marijuana et les produits ou services connexes.
</li> <li>
Entreprises de marketing multi-niveaux.
</li> <li>
Pratiques de souscription «option négative» de marketing, de renouvellement ou de continuité; activités de marketing impliquant des trajets peu coûteux, «ne payez que pour l'expédition» et / ou des «périodes d'essai gratuites» après lesquelles une carte de crédit est débitée périodiquement et / ou un montant considérablement plus important.
</li> <li>
Prêteur sur gage.
</li> <li>
Pseudo-produits pharmaceutiques.
</li> <li>
Voyants et entreprises «occultes».
</li> <li>
Quasi-espèces ou valeur stockée.
</li> <li>
Substances conçues pour imiter des drogues illégales.
</li> <li>
Transaction de monnaie virtuelle ou de crédits pouvant être monétisés, revendus ou convertis en biens ou services physiques ou numériques ou sortis du monde virtuel.
        </li>
    </ul>
</div>

<h5> Votre compte </h5>

<p> Vous devrez peut-être créer un compte pour utiliser certains de nos Services. Vous êtes responsable de la protection de votre compte ; nous vous invitons donc à utiliser un mot de passe fort et à limiter son utilisation à ce compte. Nous déclinons toute responsabilité en cas de perte ou de préjudice qui découlerait du non-respect par vous de ce qui précède.
</p>
<p>
Vous pourrez mettre fin à votre accord légal avec INTRAM à tout moment en désactivant vos comptes et en cessant d’utiliser ses Services. Pour désactiver votre compte, veuillez suivre les instructions figurant sur notre site web.
</p>
<p>
Les présentes Conditions d’utilisation (« Conditions ») régissent l’accès et l’utilisation par vous-même de nos services, y compris nos différents sites Web, SMS, API, notifications par e-mail, applications, boutons, widgets, publicités, services de transactions commerciales, et nos autres services couverts renvoyant à ces Conditions (collectivement, les « Services »), ainsi que les informations, textes, liens, graphiques, photos, sons, vidéos ou autres éléments ou combinaison d’éléments téléchargés à partir des Services ou apparaissant sur ceux-ci (collectivement dénommés le « Contenu »). En utilisant les Services, vous reconnaissez être lié(e) par les présentes Conditions.
</p>
<p>
Nous pouvons réviser ces conditions de temps à autre. Les modifications ne seront pas rétroactives. Nous essaierons également de vous informer de tout changement important qui pourrait être effectué par courrier électronique associé à votre notification de compte ou de service. En continuant à utiliser nos services après l'entrée en vigueur des modifications, vous acceptez d'être lié par les Conditions révisées.
</p>
                                           
                                            </div>
                                        </v-col>
                                        <v-col>
                                           <label for="acceptConditionBtn">
                                                <input v-model="accepte" type="checkbox" id="acceptConditionBtn"> j'ai lu et j'accepte les conditions d'utilisation ci dessus.
                                                </label>
                                        </v-col>
                                        <v-col>
                                         <v-btn color="secondary" class="mr-2"  small @click="logoutUser()">{{$t('leave')}}</v-btn>
                                    
                                       <v-btn  small  :disabled="mis || !accepte" color="primary"  @click.prevent="save">{{$t('save')}}</v-btn>
                                   </v-col>
                                    </v-stepper-content>
                                </v-stepper-items>
                            </v-stepper>


                        </v-form>

                    </v-card>

        </v-dialog>
    </v-layout>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "ModalNewCompte",
        data () {
            return {
                dialog: true,
                picker: new Date().toISOString().substr(0, 10),
                tabs: null,
                bars: [
                    { class: 'primary', dark: true },
                ],
                submitting:false,
                valid:true,
                lazy:false,
                accepte:false,
                mis:false,
                e1: 1,
                errors: {},
                countryHasChanged:false,
                categorieHasChanged:false,
                search: '',
                id:undefined,
                headers: [

                ],
                editedIndex: -1,
                editedItem: {
                    _user_id: '',
                    _web_site: '',
                    _company: '',
                    _acronyme: '',
                    _email: '',
                    _base_url_site_web: '',
                    _categorie_id: '',
                    _url_checkout: '',
                    _url_success: '',
                    country: '',
                    _url_error: '',
                    _numCard: '',
                    _fileCard: '',
                    _numRCCM: '',
                    _fileRCCM: '',
                    _fileCar: '',
                    _fileRCC: '',
                    _fileIF: '',
                    _numIFU: '',
                    _fileIFU: '',
                    _valide: false,
                    _created_at: 0,
                    _id:0
                },
                defaultItem: {
                    _user_id: '',
                    _web_site: '',
                    _company: '',
                    _acronyme: '',
                    _email: '',
                    _base_url_site_web: '',
                    _categorie_id: '',
                    _url_checkout: '',
                    _url_success: '',
                    _url_error: '',
                    country: '',
                    _numCard: '',
                    _fileCard: '',
                    _numRCCM: '',
                    _fileRCCM: '',
                    _fileCar: '',
                    _fileRCC: '',
                    _fileIF: '',
                    _numIFU: '',
                    _fileIFU: '',
                    _valide: false,
                    _created_at: 0,
                    _id:0
                },
                Web_SiteRules: [
                    v => !!v ||   this.$t('marchand.site_web_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                CompanyRules: [
                    v => !!v ||   this.$t('marchand.company_required'),
                ],
                AcronymeRules: [
                    v => !!v ||  this.$t('marchand.acronyme_required'),
                ],
                rules: {
                    required: value => !!value ||  this.$t('field_required'),
                    min: v => v!==undefined && v.length >= 8 || this.$t('min_8_caracters'),
                    match: v => v == this.password || this.$t('password_mismatch'),
                    email: v => (v.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) ||  this.$t('invalid_email'),
                    tel: v => (v.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s/0-9]*$/g)) ||  this.$t('invalid_phone'),
                    //email: v => (v.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) ||  this.$t('invalid_email'),
                },
                Base_url_siteRules: [
                    v => !!v ||   this.$t('marchand.base_url_required'),
                ],
                CategorieRules: [
                    v => !!v ||   this.$t('marchand.categorie_required'),
                ],
                Url_checkoutRules: [
                    v => !!v ||   this.$t('marchand.url_checkout_required'),
                ],
                Url_successRules: [
                    v => !!v ||   this.$t('marchand.url_success_required'),
                ],
                Url_errorRules: [
                    v => !!v ||    this.$t('marchand.url_error_required'),
                ],


                codeRules: [
                    v => !!v || 'Code required',
                ],
                numRules: [
                    v => !!v || this.$t('documents.num_passport_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                numrRules: [
                    v => !!v || this.$t('documents.num_rccm_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                numiRules: [
                    v => !!v || this.$t('documents.num_ifu_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                fileRules: [
                    v => !!v || this.$t('documents.file_passport_required'),
                    v => !v || v.size < 2000000 || 'Taille maximimun 2 MB!',

                ],

                fileiRules: [
                    v => !!v || this.$t('documents.file_ifu_required'),
                    v => v.type==='application/pdf' || this.$t('invalid_file'),
                    v => !v || v.size < 2000000 || 'Taille maximimun 2 MB!',



                ],
                filerRules: [
                    v => !!v || this.$t('documents.file_rccm_required'),
                    v => v.type==='application/pdf' || this.$t('invalid_file'),
                    v => !v || v.size < 2000000 || 'Taille maximimun 2 MB!',

                ],
                countryRules: [
                    v => !!v ||    this.$t('marchand.pays_required'),
                ],
            }
        },
        computed: {
            user : function(){
                return this.$store.getters.auth
            },

            formTitle () {
                return this.editedIndex === -1 ? this.$t('Compte business') : this.$t('Modifier information')
            },
            country:function () {
                return (this.user.country===null || this.user.country==undefined) ? {text:"Votre pays",value:"1"} :{text:this.user.country._name, value:this.user.country._id}
            },
            ...mapState('countries/',['countries']),
            ...mapState('marchands/',['marchand']),
            ...mapState('documents/',['document']),
            ...mapState('category_marchands/',['category_marchands']),


        },
        mounted(){
            this.initialize();
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            categorieChanged(){
                this.categorieHasChanged = true;
            },
            initialize () {
                console.log('User',this.$store.getters.auth)
                this.$store.dispatch('marchands/getMarchandOne').then(response => {
                    console.log('Marchand',response)
                });
                this.$store.dispatch('documents/getDocumentOne').then(response => {
                    console.log('Mon document',response)
                });
                this.$store.dispatch('category_marchands/getCategorie_Marchand').then(response => {
                    console.log('category_marchands',response)
                });
                this.$store.dispatch('countries/getCountries').then(response => {
                    console.log(response)
                });
            },
            countryChanged(){
                this.countryHasChanged = true;

            },
            close () {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save () {
                let VueBox = this;
                this.submitting = true;
                let data = new FormData();
                this.mis=true;
                let principal=true;
                data.append("user_id",this.$store.getters.auth._id);
                data.append("web_site",this.editedItem._web_site);
                data.append("email",this.editedItem._email);
                data.append("principal",principal);
                data.append("company",this.editedItem._company);
                let cat = this.editedItem._categorie_id;
                let pays = this.editedItem.country;

                if ( this.categorieHasChanged){
                    data.append("_categorie_id",cat);
                }
                if ( this.countryHasChanged){
                    data.append("country",pays);
                }

                this.$store.dispatch('nouveau_marchands/setnew',data).then((response)=>{
                    console.log('set nouveau response',response)
                    this.submitting = false;
                    if (response.error){
                        this.errors.operation=response.message;
                    }else{
                        VueBox.$parent.resetDatas(VueBox);
                        this.close();
                        VueBox.toast('success','Compte business créer. Patientez nous chargeons vos données.');
                        location.reload()
                    }
                })
            },

            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
            fileChange() {
                console.log( this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
        },

    }
</script>

<style scoped>

</style>